/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const picklistOptionSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  color: z.string(),
  createdAt: z.iso.datetime(),
  fieldId: z.int(),
  id: z.int(),
  name: z.string(),
  priority: z.string(),
  updatedAt: z.iso.datetime(),
});
